export function getGoalListState(data = {}, { teamView = false } = {}) {
  const goals = Array.isArray(data.goals) ? data.goals : [];
  // The previous team endpoint excluded Draft and unset progress states.
  const goalList = teamView
    ? goals.filter(goal => goal.goal_progress_state_id != null && goal.goal_progress_states !== 'Draft')
    : goals;
  const cascadingGoalList = Array.isArray(data.cascading_goals) ? data.cascading_goals : [];
  const allGoals = goalList.concat(...cascadingGoalList.map(cascade =>
    Array.isArray(cascade.goals_for_cascading) ? cascade.goals_for_cascading : []
  ));
  const subGoalsByGoalId = {};
  const ownedGoals = new Map();

  allGoals.forEach(goal => {
    subGoalsByGoalId[goal.id] = Array.isArray(goal.sub_goals) ? goal.sub_goals : [];
  });
  // Cascades include other employees' goals; only owned goals count toward weightage.
  goalList.concat(allGoals.filter(goal => goal.is_goal_owner === true)).forEach(goal => {
    ownedGoals.set(goal.id, goal);
  });
  const userGoalList = Array.from(ownedGoals.values());
  const totalWeight = userGoalList.reduce(
    (sum, goal) => sum + (parseFloat(goal.goal_weight || goal.weight || 0) || 0), 0
  );

  return { goalList, cascadingGoalList, subGoalsByGoalId, userGoalList, totalWeight };
}
